import { apiClient, unwrap } from './client';
import type { ApiSuccess } from '@/types/api';
import type { Product } from '@/types/product';

export interface WishlistItem {
  id: number;
  userId: number;
  productId: number;
  createdAt: string;
  product: Product;
}

export const wishlistApi = {
  async list(): Promise<WishlistItem[]> {
    const res = await apiClient.get<ApiSuccess<WishlistItem[]>>('/wishlist');
    return unwrap(res);
  },

  async toggle(productId: number): Promise<{ added: boolean }> {
    const res = await apiClient.post<ApiSuccess<{ added: boolean }>>('/wishlist', {
      productId,
    });
    return unwrap(res);
  },

  async remove(productId: number): Promise<void> {
    await apiClient.delete(`/wishlist/${productId}`);
  },

  async moveToCart(productId: number, variantId: number): Promise<void> {
    await apiClient.post('/wishlist/move-to-cart', { productId, variantId });
  },
};
